import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M7 8l-4 4l4 4","key":"svg-0"}],["path",{"d":"M17 8l4 4l-4 4","key":"svg-1"}],["path",{"d":"M14 4l-4 16","key":"svg-2"}]]

/**
 * IconCode
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItY29kZSIKPgogIDxwYXRoIHN0cm9rZT0ibm9uZSIgZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIgLz4KICA8cGF0aCBkPSJNNyA4bC00IDRsNCA0IiAvPgogIDxwYXRoIGQ9Ik0xNyA4bDQgNGwtNCA0IiAvPgogIDxwYXRoIGQ9Ik0xNCA0bC00IDE2IiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/code
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconCode = createReactComponent('outline', 'code', 'Code', __iconNode);

export default IconCode;